var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.514 8.492v.991H9.81v13.034h12.704V24.5l-7.42-.057-7.45-.085-.086-8.443L7.5 7.5h15.014z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.698 10.9c1.126.312 2.108 1.19 2.425 2.182.173.595.087.651-.924.651-.78 0-1.212-.17-1.472-.566-.433-.709-2.397-.794-2.974-.114-.635.765.058 1.332 2.31 1.842 1.126.255 2.31.68 2.627.963 1.444 1.275.866 4.08-1.01 4.845-1.27.51-3.35.51-4.62 0-.866-.368-1.877-1.643-1.877-2.436 0-.51 1.877-.312 2.368.283 1.04 1.162 3.464.992 3.638-.255.144-.963-.405-1.388-2.05-1.587-2.685-.368-3.667-1.19-3.667-3.06 0-2.21 2.425-3.513 5.226-2.748z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkl);
export default __webpack_public_path__ + "static/media/skl.d3869298ec8ba7d20bd8842bc9ab66dd.svg";
export { ForwardRef as ReactComponent };